<template>
  <h3 class="pb5">Rapport sur les sociétés inactives (CDX_0256)</h3>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";

export default {
  name: "SocietesInactives",
  components: {ButtonBar},

  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      console.log("test imprimer");
    }
  },
}
</script>